import React, { useState } from 'react';
import { Button, Popover, StatusIndicator, Link, SpaceBetween, Box } from '@cloudscape-design/components';
import { shortAddr } from './wallets';

const FAUCET_URL = 'https://faucet.circle.com/';

/**
 * A wallet-address display: short form + click-to-copy, with a Circle faucet link
 * for topping up Base Sepolia testnet USDC. Used for both the buyer and seller wallets.
 */
export default function AddressChip({ address, showFaucet = false }) {
  const [copied, setCopied] = useState(false);
  if (!address) return <Box fontSize="body-s">—</Box>;

  const copy = () => {
    try {
      navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard blocked — non-fatal */
    }
  };

  return (
    <SpaceBetween direction="horizontal" size="xxs">
      <Popover
        dismissButton={false}
        position="top"
        size="small"
        triggerType="custom"
        content={<StatusIndicator type="success">Copied</StatusIndicator>}
      >
        <Button variant="inline-link" iconName="copy" onClick={copy}>
          <code>{shortAddr(address)}</code>
        </Button>
      </Popover>
      {copied ? null : null}
      {showFaucet && (
        <Link external href={FAUCET_URL} fontSize="body-s">
          fund
        </Link>
      )}
    </SpaceBetween>
  );
}
